"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpointFits = exports.useBreakpoint = exports.useCurrentBreakpoint = void 0;
const react_1 = require("react");
const getBreakpoint_1 = require("./getBreakpoint");
const compareBreakpoints_1 = require("./compareBreakpoints");
const compareBreakpoints_2 = require("./compareBreakpoints");
const useCurrentBreakpoint = (breakpointsMap) => {
    const [, startTransition] = (0, react_1.useTransition)();
    const checkBreakpointRef = (0, react_1.useRef)(() => {
        return (0, getBreakpoint_1.getBreakpoint)(window.innerWidth, breakpointsMap);
    });
    const [breakpoint, setBreakpoint] = (0, react_1.useState)(checkBreakpointRef.current);
    (0, react_1.useLayoutEffect)(() => {
        const handleCheck = () => {
            startTransition(() => setBreakpoint(checkBreakpointRef.current()));
        };
        const observer = new ResizeObserver(handleCheck);
        observer.observe(document.body);
        return () => {
            observer.unobserve(document.body);
        };
    }, []);
    return breakpoint;
};
exports.useCurrentBreakpoint = useCurrentBreakpoint;
const useBreakpoint = (point, breakpointsMap) => {
    var _a;
    const currentBp = (0, exports.useCurrentBreakpoint)((_a = compareBreakpoints_2.defaultBreakpointsMap) !== null && _a !== void 0 ? _a : breakpointsMap);
    return (0, compareBreakpoints_1.compareBreakpoints)(point, currentBp, breakpointsMap);
};
exports.useBreakpoint = useBreakpoint;
const useBreakpointFits = (point, breakpointsMap) => {
    return (0, exports.useBreakpoint)(point, breakpointsMap) === 'fits';
};
exports.useBreakpointFits = useBreakpointFits;
